import React, { createContext, useCallback, useState } from 'react';
export const defaultSelectionState = {
  selection: [],
  setSelection: () => undefined,
  allowMultiple: false
};
export const SelectionContext = /*#__PURE__*/createContext(defaultSelectionState);
export const SelectionProvider = props => {
  var _props$defaultValue;

  const {
    allowMultiple = false,
    children,
    selectionChangeCallback
  } = props;
  const [selection, setSelectionValue] = useState((_props$defaultValue = props.defaultValue) !== null && _props$defaultValue !== void 0 && _props$defaultValue.length ? props.defaultValue : []);
  const setSelection = useCallback(nodes => {
    const newSelection = allowMultiple ? nodes : nodes.slice(-1);
    setSelectionValue(newSelection);
    selectionChangeCallback === null || selectionChangeCallback === void 0 ? void 0 : selectionChangeCallback(newSelection);
  }, [allowMultiple, selectionChangeCallback]);
  return /*#__PURE__*/React.createElement(SelectionContext.Provider, {
    value: {
      selection,
      setSelection,
      allowMultiple
    }
  }, children);
};
//# sourceMappingURL=selection.js.map